import { PcmWsDataSet } from '../models/pcmws-data-set';
import { Region } from '../models/region';
import { DataVersion } from '@tmx/data-access';

export function mapDataVersionToRegion(dataVersion: DataVersion | null): {
  region: Region;
  pcmWsDataSet: PcmWsDataSet;
  mapsSdkRegion: 'af' | 'as' | 'eu' | 'me' | 'na' | 'oc' | 'sa' | 'ww';
} {
  let region: Region = 'No Region';
  let pcmWsDataSet: PcmWsDataSet = 'PCM_WW';
  let mapsSdkRegion: 'af' | 'as' | 'eu' | 'me' | 'na' | 'oc' | 'sa' | 'ww' =
    'na';

  if (dataVersion === null) {
    return { region, pcmWsDataSet, mapsSdkRegion };
  }
  switch (dataVersion) {
    case 'Current':
    case 'PCM_NA':
    case 'PCM_NA_14Q2':
    case 'PCM_NA_13Q2':
      region = 'North America';
      pcmWsDataSet = 'PCM_NA';
      mapsSdkRegion = 'na';
      break;
    case 'PCM_EU':
      region = 'Europe';
      pcmWsDataSet = 'PCM_EU';
      mapsSdkRegion = 'eu';
      break;
    case 'PCM_AF':
      region = 'Africa';
      pcmWsDataSet = 'PCM_AF';
      mapsSdkRegion = 'af';
      break;
    case 'PCM_AS':
      region = 'Asia';
      pcmWsDataSet = 'PCM_AS';
      mapsSdkRegion = 'as';
      break;
    case 'PCM_OC':
      region = 'Oceania';
      pcmWsDataSet = 'PCM_OC';
      mapsSdkRegion = 'oc';
      break;
    case 'PCM_SA':
      region = 'South America';
      pcmWsDataSet = 'PCM_SA';
      mapsSdkRegion = 'sa';
      break;
    case 'PCM_ME':
      region = 'Middle East';
      pcmWsDataSet = 'PCM_ME';
      mapsSdkRegion = 'me';
      break;
    default:
      region = 'No Region';
      pcmWsDataSet = 'PCM_WW';
      mapsSdkRegion = 'ww';
      break;
  }
  return { region, pcmWsDataSet, mapsSdkRegion };
}
